import React from "react"
import { Box, Typography } from "@mui/material"
import Person2OutlinedIcon from "@mui/icons-material/Person2Outlined"

import { Wysiwyg } from "shared/ui/berry-jass"
import { TasksTable } from "entities/activity-event"
import { getAlternativeContactsOptionLabel } from "entities/contact"

export const ActivityEventsTableSubComponent = ({ row, customerId }) => {
  const { id, description, contact } = row.original

  return (
    <Box sx={{ py: 0, pl: 2 }}>
      {contact && (
        <Box display="flex" alignItems="center">
          <Person2OutlinedIcon
            color="primary"
            sx={{ fontSize: "16px", mr: "8px" }}
          />
          <Typography
            sx={{
              fontSize: 12,
              fontWeight: 400
            }}
          >
            {getAlternativeContactsOptionLabel(contact)}
          </Typography>
        </Box>
      )}
      {!!description && (
        <Typography
          sx={{
            fontSize: 12,
            fontWeight: 400
          }}
        >
          <Wysiwyg readOnly value={description} />
        </Typography>
      )}

      <TasksTable customerId={customerId} eventId={id} emptyState={<></>} />
    </Box>
  )
}
